module.exports = __webpack_public_path__ + "static/media/rural-wifi.20367540.png";